module.exports = __webpack_public_path__ + "img/img.d7a46e74.png";